import { addClass, removeClass, onlyAllowNumbers } from './_utilities';

// show spinner
const showSpinner = (el) => {
    // remove span text, icon and show svg spinner
    const buttonWidth = el;
    removeClass(el, 'button--hide-spinner');
    addClass(el, 'button--show-spinner');
    el.style.width = `${buttonWidth}px`;
};

// hide spinner
const hideSpinner = (el) => {
    removeClass(el, 'button--show-spinner');
    addClass(el, 'button--hide-spinner');
};

// display "zip invalid" error
const toggleZipInvalidError = (zipChecker, state) => {
    const formErrorEl = zipChecker.classList.contains('ca-form')
        ? zipChecker.parentElement.querySelector('.form-error')
        : zipChecker.querySelector('.form-error');

    const formInputEl = zipChecker.querySelector('input[type=tel]');
    if (state === 'hide') {
        removeClass(formErrorEl, 'is-visible');
        removeClass(formInputEl, 'is-invalid-input');
        formErrorEl.innerHTML = '';
    } else {
        addClass(formErrorEl, 'is-visible');
        addClass(formInputEl, 'is-invalid-input');
        formErrorEl.innerHTML = 'Please enter a valid zip code.';
    }
};

// check zip code against MAPI
const externalZipCheck = (zip, zipChecker) => {
    const link = `/wp/wp-admin/admin-ajax.php?action=zipcheck&zip=${zip}`;
    fetch(link, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
    })
        .then((res) => res.json()) // parse response as JSON (can be res.text() for plain response)
        .then((response) => {
            if (response.valid === 'true') {
                // zip is valid

                // display 'results-not-found' div
                const resultsNotFoundDiv = zipChecker.querySelectorAll(
                    '[data-results-not-found]'
                );

                removeClass(resultsNotFoundDiv[0], 'hide');

                // set href for 'See Providers' button
                const href = `/compare-providers?zip=${zip}`;
                const seeProviders = zipChecker.querySelectorAll(
                    '[data-see-providers]'
                );
                seeProviders[0].setAttribute('href', href);
            } else {
                // zip is invalid (did not validate against MAPI)
                toggleZipInvalidError(zipChecker, 'show');
            }
        })
        .catch((err) => {
            if (err.status === 404) {
                toggleZipInvalidError(zipChecker, 'show');
            } else {
                console.error('Error: ', err);
                toggleZipInvalidError(zipChecker, 'show');
            }
        });

    // hide spinner
    const zipCheckerSubmitButton = zipChecker.querySelector(
        'button[type="submit"]'
    );
    hideSpinner(zipCheckerSubmitButton);
};

// handle response data
const handleResponse = (response, zip, zipChecker) => {
    /* eslint-disable */
    // bind to first array index for easy reference

    const firstIndex = response.search.landline;
    const brandSlug = zipChecker.getAttribute('data-brand-slug');
    const sandstoneSlug =
        zipChecker.getAttribute('data-sandstone-slug') ?? null;
    let resultsFoundDiv = '';
    let resultsNotFoundDiv = '';
    let caContainer = '';
    let seeProviders = '';

    if (typeof firstIndex !== 'undefined') {
        // check if provider is found
        let providerFound = false;
        response.search.landline.forEach((provider, index) => {
            if (provider.provider.slug === sandstoneSlug) {
                providerFound = true;
            }
        });

        // grab spinner (submit) button
        const zipCheckerSubmitButton = zipChecker.querySelector(
            'button[type="submit"]'
        );

        if (providerFound) {
            if (zipChecker.classList.contains('ca-form')) {
                caContainer = zipChecker.parentElement;

                if (zipChecker.querySelector('input[name="auto_redirect"]')) {
                    // auto redirect
                    let providerHref = zipChecker.parentElement.querySelector(
                        '.results-found div a'
                    ).href;

                    dataLayer.push({
                        event: 'serviceAvailable',
                        provider: brandSlug,
                    });

                    document.location = providerHref;
                }

                caContainer.querySelector('.ca-btn ').classList.add('hide');
                caContainer
                    .querySelector('.zip-checker__results')
                    .classList.add('on');
                caContainer
                    .querySelector('.zip-checker__fields')
                    .classList.add('hide');
                caContainer.querySelector(
                    '.results-found__text'
                ).innerHTML = `Available in ${zip}`;

                resultsFoundDiv = caContainer.querySelector(
                    '[data-results-found]'
                );
            } else {
                // display 'results-found' div
                resultsFoundDiv = zipChecker.querySelector(
                    '[data-results-found]'
                );
            }

            removeClass(resultsFoundDiv, 'hide');
            // hide spinner
            hideSpinner(zipCheckerSubmitButton);
        } else {
            // if the validated provider response has AOA, state and city data (from DB) then redirect safely knowing the
            // '/ST/City' path can be established successfully
            if (
                firstIndex.is_aoa !== null &&
                firstIndex.state !== null &&
                firstIndex.city !== null
            ) {
                if (zipChecker.classList.contains('ca-form')) {
                    caContainer = zipChecker.parentElement;

                    // on the check availability form, hide the form
                    caContainer.querySelector('.ca-btn ').classList.add('hide');
                    caContainer
                        .querySelector('.zip-checker__results')
                        .classList.add('on');
                    caContainer
                        .querySelector('.zip-checker__fields')
                        .classList.add('hide');
                    resultsNotFoundDiv = caContainer.querySelector(
                        '[data-results-not-found]'
                    );
                    const unavailableInZipContent = `
                    <div class="ca-unavailable-btn-container">
                        <a class="button button--generic-color3 button--is-big button--is-auto-width ca-unavailable-btn ca-toggle-form">Unavailable</a>
                        <a href="javascript:;" class="ca-pencil ca-toggle-form">
                            <img src="/app/themes/bifrost-child/dist/images/icons/pencil.svg" alt="edit zip" loading="lazy" class="ca-toggle-form"/>
                        </a>
                    </div>
                    <a href="javascript:;" class="padding-top-mini inline-block" data-see-providers>Find providers in <span class="ca-notfound-zip"></span></a>`;
                    resultsNotFoundDiv.innerHTML = unavailableInZipContent;
                    caContainer.querySelector('.ca-notfound-zip').textContent =
                        zip;
                    seeProviders = caContainer.querySelector(
                        '[data-see-providers]'
                    );
                } else {
                    resultsNotFoundDiv = zipChecker.querySelector(
                        '[data-results-not-found]'
                    );
                    seeProviders = zipChecker.querySelector(
                        '[data-see-providers]'
                    );
                }

                const href = `/${response.state.toLowerCase()}/${
                    response.city_slug
                }?zip=${zip}`;

                // display 'results-not-found' div

                removeClass(resultsNotFoundDiv, 'hide');

                // set href for 'See Providers' button

                seeProviders.setAttribute('href', href);

                // hide spinner
                hideSpinner(zipCheckerSubmitButton);
            } else {
                // if zip fails to validate against local DB (no non-satellite providers returned), attempt an external zip check
                // to validate the zip submitted. If it's valid, then we'll just return the satellite providers
                // on the /compare-providers page.
                externalZipCheck(zip, zipChecker);
            }
        }
    } else {
        // console.log('no preliminary response');

        // hide spinner
        hideSpinner(zipCheckerSubmitButton);
    }
    /* eslint-enable */
};

// check zip against local DB
const checkZip = (zip, zipChecker) => {
    /* eslint-disable */
    // check for valid integer
    const zipPattern = /^\d{5}$/;
    const isValid = zipPattern.test(zip);
    const zipCheckerSubmitButton = zipChecker.querySelector(
        'button[type="submit"]'
    );

    if (isValid) {
        const link = `/wp/wp-admin/admin-ajax.php?action=getAllZipData&zip=${zip}`;
        fetch(link, {
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
        })
            .then((res) => res.json()) // parse response as JSON (can be res.text() for plain response)
            .then((response) => {
                // hide spinner
                if (response != null && response.name) {
                    handleResponse(response, zip, zipChecker);
                } else {
                    toggleZipInvalidError(zipChecker, 'show');
                    hideSpinner(zipCheckerSubmitButton);
                }
            })
            .catch((err) => {
                console.log(err);
                hideSpinner(zipCheckerSubmitButton);
            });
    } else {
        // zip not valid
        toggleZipInvalidError(zipChecker, 'show');

        // hide spinner
        hideSpinner(zipCheckerSubmitButton);
    }

    /* eslint-enable */
};

// push events for Optimizely tracking
const pushOptimizelyEvents = (zip) => {
    window.optimizely = window.optimizely || [];
    window.optimizely.push(['trackEvent', `zip_${zip}`]);
};

// push form location for GTA tracking
const pushFormLocation = (location) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'form-location': location,
    });
};

// handle zip checker form submission
const submitForm = (e) => {
    // Stop default form behavior
    e.preventDefault();

    const { zipCheckerArray, inputElement } = e.data;

    zipCheckerArray.forEach((zipChecker) => {
        zipChecker.querySelector('input[type=tel]').value = inputElement.value;
    });

    // bind to form elements
    const zipChecker = e.target;
    const zipCheckerSubmitButton = zipChecker.querySelector(
        'button[type="submit"]'
    );
    const zipInputEl = zipChecker.elements.zipcode;
    const zipValue = zipInputEl.value;
    const formLocation = zipChecker.getAttribute('data-form-location');
    let resultsFoundDiv = '';
    let resultsNotFoundDiv = '';

    zipInputEl.blur();

    // hide results divs
    toggleZipInvalidError(zipChecker, 'hide');

    if (zipChecker.classList.contains('ca-form')) {
        resultsFoundDiv = zipChecker.parentElement.querySelector(
            '[data-results-found]'
        );
        addClass(resultsFoundDiv, 'hide');
        resultsNotFoundDiv = zipChecker.parentElement.querySelector(
            '[data-results-not-found]'
        );
        addClass(resultsNotFoundDiv, 'hide');
    } else {
        resultsFoundDiv = zipChecker.querySelectorAll('[data-results-found]');
        addClass(resultsFoundDiv[0], 'hide');
        resultsNotFoundDiv = zipChecker.querySelectorAll(
            '[data-results-not-found]'
        );
        addClass(resultsNotFoundDiv[0], 'hide');
    }

    // show spinner
    showSpinner(zipCheckerSubmitButton);

    // if we don't have a value, just highlight the input field
    if (!zipValue || zipValue.length < 5) {
        toggleZipInvalidError(zipChecker);
        zipInputEl.focus();
        hideSpinner(zipCheckerSubmitButton);
    } else {
        document.cookie = 'zipChecker=true; expires=0; path=/';

        // Broadcast Optimizely events
        pushOptimizelyEvents(zipValue);

        // push GTA form location
        pushFormLocation(formLocation);

        // attempt to validate zip, first locally and then remotely upon local failure
        checkZip(zipValue, zipChecker);
    }
};

const checkAvailability = () => {
    document.querySelector('body').addEventListener('click', (e) => {
        // click on the Check Availability button
        if (e.target.classList.contains('ca-btn--availability')) {
            const i = e.target;
            // set whatever this is in to its current width
            const checkContainer = i.parentElement;
            const formWidth = checkContainer.clientWidth;

            if (checkContainer.parentElement.tagName === 'TD') {
                checkContainer.parentElement.style.width = `${formWidth}px`;
            }

            checkContainer.style.width = `${formWidth}px`;
            checkContainer.querySelector(
                '.zip-checker__input__secondary'
            ).style.width = `${formWidth}px`;

            // set width and height on element to maintain consistency
            i.style.width = `${formWidth}px`;
            i.classList.add('off');

            checkContainer.querySelector('input[name="zipcode"]').focus();
        }

        // click the "check new zip" button
        if (e.target.classList.contains('ca-toggle-form')) {
            const i = e.target;

            const resultsContainer = i.closest('.zip-checker__results');
            const caContainer = resultsContainer.parentElement;

            resultsContainer.classList.remove('on');
            caContainer
                .querySelector('.zip-checker__fields')
                .classList.remove('hide');
            caContainer.querySelector('.results-not-found').innerHTML = '';
            caContainer.querySelector('.ca-btn ').classList.remove('hide');
            caContainer.querySelector('input[name="zipcode"]').value = '';
            caContainer.querySelector('input[name="zipcode"]').focus();
        }
    });
};

// Module startup
const init = (zipChecker = false) => {
    // Determine module to load based off of script tag data attribute
    const zipCheckerArray = document.querySelectorAll('[data-zip-checker]');
    checkAvailability();
    // Check to make sure we have zip forms on page
    if (zipCheckerArray !== null && zipCheckerArray.length > 0 && !zipChecker) {
        // Loop/map through all zip form elements
        zipCheckerArray.forEach((zipCheck) => {
            // Disallow characters entered into zip input
            const inputElement = zipCheck.querySelector('input[type=tel]');
            if (inputElement) {
                onlyAllowNumbers(inputElement);
            }

            // Add submit event listener for each form
            $(zipCheck).on(
                'submit',
                { zipCheckerArray, inputElement },
                submitForm
            );
        });
    } else if (zipChecker) {
        const inputElement = zipChecker.querySelector('input[type=tel]');

        onlyAllowNumbers(inputElement);
        $(zipChecker).on(
            'submit',
            { zipCheckerArray: [zipChecker], inputElement },
            submitForm
        );
    }
};

export { init };
